declare global {
  interface Window {
    Tawk_API?: any;
    Tawk_LoadStart?: Date;
  }
}

export const initializeTawkTo = () => {
  if (typeof window === "undefined") return;

  // Initialize Tawk_API global if not exists
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = window.Tawk_LoadStart || new Date();

  // Prevent multiple injections
  if (document.getElementById("tawk-script")) return;

  // If the script was removed (e.g., from a restricted page), but memory objects remain,
  // we need to wipe them out now. Otherwise, the re-injected script thinks the widget
  // is already fully initialized and refuses to rebuild the iframe and DOM elements.
  try {
    delete (window as any).Tawk_Window;
    delete (window as any).$_Tawk;
  } catch (e) {}

  // Re-initialize for fresh boot
  window.Tawk_API = {};
  window.Tawk_LoadStart = new Date();

  const s1 = document.createElement("script");
  // Use specific ID to track this script
  s1.id = "tawk-script";
  s1.async = true;
  s1.src = "https://embed.tawk.to/685c287eeef0f3190ce9b749/1iujvsb7e";
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");

  const s0 = document.getElementsByTagName("script")[0];
  if (s0 && s0.parentNode) {
    s0.parentNode.insertBefore(s1, s0);
  } else {
    document.head.appendChild(s1);
  }
};

export const openTawkToChat = () => {
  if (typeof window === "undefined") return;

  if (window.Tawk_API && window.Tawk_API.maximize) {
    window.Tawk_API.maximize();
  } else {
    initializeTawkTo();
  }
};

export const removeTawkTo = () => {
  if (typeof window === "undefined") return;

  // Utilize Tawk's built-in methods first if available to stop sound/status
  if (window.Tawk_API) {
    try {
      if (window.Tawk_API.hideWidget) window.Tawk_API.hideWidget();
    } catch (e) {}
  }

  // Remove the main injected script
  document
    .querySelectorAll('script[src*="tawk.to"]')
    .forEach((s) => s.remove());
  const script = document.getElementById("tawk-script");
  if (script) script.remove();

  // Remove exact style elements provided in the DOM reference
  document
    .querySelectorAll("style.tawk-global-variables")
    .forEach((style) => style.remove());

  // Remove any iframes loaded from tawk.to or containing the chat widget
  document.querySelectorAll("iframe").forEach((iframe) => {
    try {
      const title = iframe.title.toLowerCase();
      if (
        iframe.src.includes("tawk.to") ||
        title.includes("chat widget") ||
        title.includes("chat") ||
        iframe.style.zIndex === "1000003" ||
        iframe.style.zIndex === "2147483647"
      ) {
        // Clearing src stops network requests in progress inside the iframe (including Websocket audio)
        iframe.src = "about:blank";
        iframe.remove();
      }
    } catch (e) {}
  });

  // Remove DOM containers injected by Tawk
  const tawkDivs = document.querySelectorAll(
    'div[class*="tawk"], div[id*="tawk"]'
  );
  tawkDivs.forEach((div) => div.remove());

  // Look for the specific Tawk widget wrapper at body level
  setTimeout(() => {
    const customWrappers = document.querySelectorAll(
      'div[style*="z-index: 2147483647"], div[style*="z-index: 1000003"]'
    );
    customWrappers.forEach((div) => {
      // Typically the Tawk widget has this extremely high z-index and uses an iframe inside
      if (
        div.innerHTML.includes("tawk.to") ||
        div.innerHTML.includes("chat") ||
        div.innerHTML.includes("tawk")
      ) {
        div.remove();
      }
    });

    // Reset window.Tawk_API cleanly for next initialization
    // We explicitly avoid deleting Tawk_Window or $_Tawk because Tawk's
    // lingering setTimeouts/setIntervals crash if these disappear unexpectedly.
    window.Tawk_API = {};
  }, 100);
};
